import replaceSpecialCharInImageName from '@/app/utils/replaceSpecialCharInImageName';
import hasImageUploadCare from '@/app/utils/hasImageUploadCare';
/**
 * Function check url hosted by Shopify CDN
 * @param src {string}
 * @returns boolean
 */
export const hasImageShopify = (src: string): boolean => {
  if (!src) {
    return false;
  }
  if (src.indexOf('cdn.shopify.com/s/files/') != -1) {
    return true;
  } else if (src.indexOf('apps.shopifycdn.com/') != -1) {
    return true;
  }
  return false;
};

/**
 * Check Url is include file name or not
 * @param src string
 * @returns true/false
 */
export const isIncludeFileName = (src: string): boolean => {
  let result = false;
  if (/\.(gif|jpe?g|tiff|png|webp|bmp)$/i.test(src)) {
    result = true;
  }
  return result;
};

/**
 * remove all item of array as: "",undefined,blank...
 * @param actual array cần clearn
 * @returns clearn array
 */
export const cleanArray = (actual: any): any => {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
};

/**
 * urlImageHasName
 * @param src :string
 * @param expectedSize :string
 * @returns src
 */
export const imageUrlHasName = (src: string, expectedSize: string): any => {
  let imageName;
  const pathItem = cleanArray(new URL(src).pathname.split('/'));
  const realURL = pathItem[0];
  if (isIncludeFileName(src)) {
    imageName = pathItem.pop();
  }
  let imgUrl;
  if (new URL(src).pathname.includes('//')) {
    imgUrl = new URL(src).origin + `//${realURL}`;
  } else {
    imgUrl = new URL(src).origin + `/${realURL}`;
  }
  const identifies = src.split('/-');
  if (identifies && identifies.length) {
    const totalIdentifies = identifies.length;

    // See more operators at https://uploadcare.com/features/image_processing/
    const operators = identifies.slice(1, totalIdentifies);

    if (operators && operators.length) {
      let lastOperators = operators[operators.length - 1];
      if (imageName && encodeURI(lastOperators).includes(imageName)) {
        const regex = new RegExp(imageName, 'g');
        lastOperators = encodeURI(lastOperators).replace(regex, '');
      }
      operators[operators.length - 1] = lastOperators;
    }

    // Support case not exist preview operator
    const previewOpFound = operators.find((e) => e.includes('preview'));
    if (!previewOpFound) {
      operators.unshift('/preview');
    }

    for (let i = 0; i < operators.length; i++) {
      let op = operators[i];
      if (operators[i][0] == '/') {
        // Remove character '/' at the first of string
        op = operators[i].slice(1, op.length);
      }

      if (operators[i][op.length - 1] == '/') {
        // Remove character '/' at the end of string
        op = operators[i].slice(0, op.length - 1);
      }
      // Support operator preview
      if (op.includes('preview')) {
        let newOp = operators[i];
        if (expectedSize.includes('x')) {
          let sizeSplit = expectedSize.split('x');
          if (sizeSplit && sizeSplit.length) {
            sizeSplit = sizeSplit.filter((e) => e.trim().length);
            // x100 or 100x => 100x100
            if (sizeSplit.length == 1) {
              expectedSize = sizeSplit[0] + 'x' + sizeSplit[0];
            }
          }
        } else {
          // 100 => 100x100
          if (!isNaN(parseInt(expectedSize))) {
            expectedSize = expectedSize + 'x' + expectedSize;
          }
        }
        newOp = `/preview/${expectedSize}`;
        if (operators && operators.length == 1 && operators[0] == '/preview') {
          newOp += '/';
        }
        operators[i] = newOp;
      }
    }
    src = imgUrl + '/-' + operators.join('/-');
    if (imageName && !isIncludeFileName(src)) {
      const operatorString = operators.join('/-');
      let hasSlash = false;
      if (operatorString.charAt(operatorString.length - 1) == '/') {
        hasSlash = true;
      }
      src = hasSlash
        ? imgUrl + '/-' + operatorString + `${imageName}`
        : imgUrl + '/-' + operators.join('/-') + `/${imageName}`;
    }
  }
  return src;
};

/**
 * replace name image
 * @param src :string
 * @param expectedSize :string
 * @returns src
 */
export const imageUrlReplaceName = (src: string, expectedSize: string): any => {
  let imageName;
  const pathItem = cleanArray(new URL(src).pathname.split('/'));
  const realURL = pathItem[0];
  if (isIncludeFileName(src)) {
    imageName = pathItem.pop();
  }
  let imgUrl;
  if (new URL(src).pathname.includes('//')) {
    imgUrl = new URL(src).origin + `//${realURL}`;
  } else {
    imgUrl = new URL(src).origin + `/${realURL}`;
  }
  const identifies = new URL(src).pathname.split('/-');
  if (identifies && identifies.length) {
    const totalIdentifies = identifies.length;

    // See more operators at https://uploadcare.com/features/image_processing/
    const operators = identifies.slice(1, totalIdentifies);

    // Dùng đề tách imageName và lấy operators last
    if (operators && operators.length) {
      let lastOperators = operators[operators.length - 1];
      if (imageName && lastOperators.includes(imageName)) {
        lastOperators = lastOperators.replace(imageName, '');
      }
      operators[operators.length - 1] = lastOperators;
    }

    if (imageName) {
      imageName = replaceSpecialCharInImageName(imageName);
    }

    // Support case not exist preview operator
    const previewOpFound = operators.find((e) => e.includes('preview'));
    if (!previewOpFound) {
      operators.unshift('/preview');
    }

    for (let i = 0; i < operators.length; i++) {
      let op = operators[i];
      if (operators[i][0] == '/') {
        // Remove character '/' at the first of string
        op = operators[i].slice(1, op.length);
      }

      if (operators[i][op.length - 1] == '/') {
        // Remove character '/' at the end of string
        op = operators[i].slice(0, op.length - 1);
      }
      // Support operator preview
      if (op.includes('preview')) {
        let newOp = operators[i];
        if (expectedSize.includes('x')) {
          let sizeSplit = expectedSize.split('x');
          if (sizeSplit && sizeSplit.length) {
            sizeSplit = sizeSplit.filter((e) => e.trim().length);
            // x100 or 100x => 100x100
            if (sizeSplit.length == 1) {
              expectedSize = sizeSplit[0] + 'x' + sizeSplit[0];
            }
          }
        } else {
          // 100 => 100x100
          if (!isNaN(parseInt(expectedSize))) {
            expectedSize = expectedSize + 'x' + expectedSize;
          }
        }
        newOp = `/preview/${expectedSize}`;
        if (operators && operators.length == 1 && operators[0] == '/preview') {
          newOp += '/';
        }
        operators[i] = newOp;
      }
    }
    src = imgUrl + '/-' + operators.join('/-');
    if (imageName && !isIncludeFileName(src)) {
      const operatorString = operators.join('/-');
      let hasSlash = false;
      if (operatorString.charAt(operatorString.length - 1) == '/') {
        hasSlash = true;
      }
      src = hasSlash
        ? imgUrl + '/-' + operatorString + `${imageName}`
        : imgUrl + '/-' + operators.join('/-') + `/${imageName}`;
    }
  }
  return src;
};

/**
 * urlImageHasName
 * @param src :string
 * @param expectedSize :string
 * @returns src
 */
export const imageUrlHasNoName = (src: string, expectedSize: string): any => {
  const identifies = src.split('/-');
  if (identifies && identifies.length) {
    const totalIdentifies = identifies.length;
    let imgUrl = identifies[0];
    // Get valid URL
    // Replace host from url
    let realURL = imgUrl.replace('https://', '').replace('http://', '');
    // Check if url has file name
    if (/\.(gif|jpe?g|tiff|png|webp|bmp)$/i.test(realURL)) {
      const splitRealURL = realURL.split('/');
      splitRealURL.pop();
      realURL = splitRealURL.join('/');
    }
    if (imgUrl.includes('https')) {
      imgUrl = `https://${realURL}`;
    } else if (imgUrl.includes('http')) {
      imgUrl = `http://${realURL}`;
    }
    // See more operators at https://uploadcare.com/features/image_processing/
    const operators = identifies.slice(1, totalIdentifies);
    // Support case not exist preview operator
    const previewOpFound = operators.find((e) => e.includes('preview'));
    if (!previewOpFound) {
      operators.unshift('/preview');
    }
    for (let i = 0; i < operators.length; i++) {
      let op = operators[i];
      if (operators[i][0] == '/') {
        // Remove character '/' at the first of string
        op = operators[i].slice(1, op.length);
      }
      if (operators[i][op.length - 1] == '/') {
        // Remove character '/' at the end of string
        op = operators[i].slice(0, op.length - 1);
      }
      // Support operator preview
      if (op.includes('preview')) {
        let newOp = operators[i];
        if (expectedSize.includes('x')) {
          let sizeSplit = expectedSize.split('x');
          if (sizeSplit && sizeSplit.length) {
            sizeSplit = sizeSplit.filter((e) => e.trim().length);
            // x100 or 100x => 100x100
            if (sizeSplit.length == 1) {
              expectedSize = sizeSplit[0] + 'x' + sizeSplit[0];
            }
          }
        } else {
          // 100 => 100x100
          if (!isNaN(parseInt(expectedSize))) {
            expectedSize = expectedSize + 'x' + expectedSize;
          }
        }
        newOp = `/preview/${expectedSize}`;
        if (operators && operators.length == 1 && operators[0] == '/preview') {
          newOp += '/';
        }
        operators[i] = newOp;
      }
    }
    src = imgUrl + '/-' + operators.join('/-');
  }
  return src;
};

/**
 * Xin chào
 * @param src alo
 * @param expectImageSize hello
 * @param dataTest :any
 * @returns alo
 */
export default (src: string, expectImageSize: string, dataTest?: any): string => {
  if (!src || expectImageSize == undefined || expectImageSize == null) {
    return src;
  }

  const expectedSize = expectImageSize;

  if (hasImageShopify(src)) {
    const ignore = ['jfif'];
    let params = '';
    const splitParams = src.split('?');
    if (splitParams && splitParams.length && splitParams.length >= 2) {
      params = splitParams[1];
    }
    const arrImage = splitParams[0].split('/').pop();
    const slugName = arrImage?.split('.');
    const strExtention = slugName?.pop();
    if (strExtention && ignore.indexOf(strExtention) !== -1) {
      return src;
    }
    let nameImages = slugName?.join('.');
    const arrayNames = nameImages?.split('_');
    if (arrayNames && arrayNames.length >= 2) {
      const sizeCurrent = arrayNames.pop();
      const reg = new RegExp(/(\d+)x(\d+)|(\d+)x|x(\d+)/, 'gm');
      if (sizeCurrent && reg.test(sizeCurrent)) {
        const trimReg = sizeCurrent.replace(reg, '');
        if (trimReg == '') {
          // remove size
          const splitNamesBySize = nameImages?.split('_');
          splitNamesBySize?.pop();
          nameImages = splitNamesBySize?.join('_');
        }
      }
    }
    const srcImageSplit = src.split('?')[0].split('/');
    let smallSrc = '';
    for (let j = 0; j < srcImageSplit.length - 1; j++) {
      smallSrc += srcImageSplit[j] + '/';
    }
    if (expectImageSize) {
      src = smallSrc + nameImages + '_' + expectImageSize + '.' + strExtention;
    } else {
      src = smallSrc + nameImages + '.' + strExtention;
    }
    if (params) {
      src = src + '?' + params;
    }
  }

  if (hasImageUploadCare(src)) {
    src = imageUrlReplaceName(src, expectedSize);
  }
  return src;
};
